import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

function readCookie(name) {
  const m = document.cookie.match(new RegExp("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)"));
  return m ? decodeURIComponent(m.pop()) : "";
}

// Double-submit CSRF: echo the readable csrf_token cookie as a header on mutating requests.
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    const token = readCookie("csrf_token");
    if (token) config.headers["X-CSRF-Token"] = token;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const isAuthCall =
      url.includes("/auth/login") || url.includes("/auth/register") || url.includes("/auth/me") || url.includes("/auth/logout");
    const path = window.location.pathname;
    const onPublicRoute = path === "/login" || path === "/" || path === "/marketplace";
    if (status === 401 && !isAuthCall && !onPublicRoute) {
      window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);

export default api;
